<template>
  <label class="icon-box" @click="handleClick">
    <auth-img class="icon-img" :src="img" alt="" />
    <div class="icon-label">健康信息</div>
  </label>
  <a-modal v-model:visible="visible" title="健康信息" @ok="handleOk" centered>
    <a-spin :spinning="loading">
      <div>{{ text }}</div>
    </a-spin>
  </a-modal>
</template>
<script setup>
import { ref, defineProps } from 'vue'
import img from '@/assets/img/chat/health.png'
import { checkHealthInfo, sendHealthInfo } from '@/api/chat'
const props = defineProps({
  workOrderGroupInfo: {
    type: Object,
    default: () => {},
    require: true
  },
  groupId: {
    type: String,
    default: '',
    require: true
  }
})

const visible = ref(false)
const loading = ref(false)
const text = ref('')
const tips = [
  '患者暂未完善健康信息。确定提醒患者完善？',
  '患者已完善健康信息。是否还需要提醒患者完善？'
]
let ucPatientId = ''
function handleClick() {
  visible.value = true
  try {
    ucPatientId = props.workOrderGroupInfo.patientInfo.ucUserId
    checkHealthInfo({ ucPatientId }).then(res => {
      text.value = tips[res]
    })
  } catch {
    visible.value = false
  }
}
function handleOk() {
  loading.value = true
  console.log(props.groupId)
  sendHealthInfo({ ucPatientId, groupId: props.groupId })
    .then(() => {
      visible.value = false
    })
    .finally(() => {
      loading.value = false
    })
}
</script>
<style scoped lang="scss">
@import '../../index.scss';
</style>
